<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Paparan Deposit">
            <w-card bg-color="" class="">
                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">No. Deposit :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_cagaran }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">No. Fail :</h5>
                        <div class="fw-normal my1 fs-1">{{ form.no_fail }}</div>
                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Amaun Deposit (RM) :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_deposit) }}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                  <div class="xs4">
                        <h5 class="fw-semibold m0"></h5>
                        <h5 class="fw-semibold m0">Tarikh Deposit :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.dateformat(form.tarikh_daftar) }}
                        </div>
                    </div>


                    <div class="xs4">
                       <h5 class="fw-semibold m0">Kod Akaun :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.akaun_kod }} | {{ form.akaun_keterangan }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Amaun Telah Bil (RM) :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_telah_bil) }}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Status :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.status_keterangan }}
                        </div>
                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Keterangan :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.keterangan }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Amaun Belum Bil (RM) :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_belum_inbois) }}
                            <!-- {{ $zutil.currency(form.amaun_deposit - form.amaun_telah_bil) }} -->
                        </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>

                    <div class="xs4">

                    </div>

                    <div class="xs4">

                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Baki Deposit (RM) :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_baki) }}
                        </div>
                    </div>
                </w-flex>
            </w-card>

            <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
                <template #item-content.1>

                        <w-flex justify-center align-center>
                          <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  Nama :
                                </h5>
                                <span >
                                  <template v-if="form.no_id">
                                {{form.no_id.toUpperCase()}} |
                              </template>
                              <template v-if="form.nama">
                                {{form.nama.toUpperCase()}}
                                </template>
                            </span>
                            </div>
                            <div class="xs6">
                              <h5 class="fw-semibold m0">
                                  Alamat :
                                </h5>
                                <span >
                                  <template v-if="form.alamat1">
                                    {{form.alamat1.toUpperCase()}},
                                  </template>
                                  <template v-if="form.alamat2">
                                    {{form.alamat2.toUpperCase()}},
                                  </template>
                                  <template v-if="form.alamat3">
                                    {{form.alamat3.toUpperCase()}},
                                  </template>
                                  <template v-if="form.poskod">
                                    {{form.poskod.toUpperCase()}},
                                  </template>
                                  <template v-if="form.bandar">
                                    {{form.bandar.toUpperCase()}},
                                  </template>
                                  <template v-if="form.negeri">
                                    {{form.negeri.toUpperCase()}}
                                  </template>
                            </span>
                            </div>
                        </w-flex>
                        <w-flex class="mt3" wrap align-center justify-end>
                            <template  v-if="form.lkp_deposit_status_id == 3 && $zutil.can('Batal Deposit')">
                                <w-button class="my1" bg-color="error-dark1" dark @click="BatalDeposit()">
                                     <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                                </w-button>
                                &nbsp;&nbsp;
                            </template>
                            <w-button
                                class="my1"
                                bg-color="warning"
                                dark
                                @click="back()"
                                >Kembali</w-button
                            >
                        </w-flex>

                </template>

                <template #item-content.2>

                        <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td>No</td>
                                            <td>Tarikh</td>
                                            <td>Jenis Transaksi</td>
                                            <td>No Rujukan</td>
                                            <td>Keterangan</td>
                                            <td>Amaun (RM)</td>
                                            <td>Baki Deposit (RM)</td>
                                            <td>Dokumen</td>
                                            <td>Status</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                dt, index
                                            ) in form.deposit_trans"
                                        >
                                            <td>{{ index + 1 }}</td>
                                            <td>
                                                {{
                                                    $zutil.dateformat(
                                                        dt.created_at
                                                    )
                                                }}
                                            </td>
                                            <td>
                                                {{
                                                    dt.deposit_trans_keterangan
                                                }}
                                            </td>
                                            <td>{{ dt.no_rujukan }}</td>
                                            <td>{{ dt.keterangan }}</td>
                                            <td align="right">
                                                {{ $zutil.currency(dt.amaun) }}
                                            </td>
                                            <td align="right">
                                                {{ $zutil.currency(dt.baki) }}
                                            </td>
                                            <td>
                                                <template
                                                    v-if="dt.lampiran_nama"
                                                >
                                                    <a
                                                        :href="dt.lampiran_url.replace('http://ihasil-deposit:30006/', 'https://ihasil.kedah.gov.my/api/deposit-service/')"
                                                        >{{
                                                            dt.lampiran_nama
                                                        }}</a
                                                    >
                                                </template>
                                            </td>
                                            <td>{{ dt.status_trans }}
                                                <w-button @click="showInfo(dt)">
                                                    <w-icon v-on="on"> fal fa-file </w-icon>
                                                </w-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                        <w-dialog
                          v-model="dialogDetail.show"
                          :fullscreen="dialogDetail.fullscreen"
                          :width="dialogDetail.width"
                          :persistent="dialogDetail.persistent"
                          :persistent-no-animation="dialogDetail.persistentNoAnimation"
                          title-class="primary-light1--bg white">
                          <template #title>
                            <!-- <w-icon class="mr2">fal fa-user</w-icon> -->
                            Butiran Transaksi
                          </template>
                          <div class="page-wrapper-portal">
                              <div class="table-profil-scrol">
                              <template v-if="dialogDetail.data.lkp_deposit_trans_id == 1">
                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Jenis Transaksi:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.deposit_trans_keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Tarikh :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{$zutil.dateformat(dialogDetail.data.created_at)}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                      <h5 class="fw-semibold m0">No Rujukan :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.no_rujukan}}
                                        </div>
                                    </div>
                                </w-flex>

                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Keterangan:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Amaun (RM) :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{ $zutil.currency(dialogDetail.data.amaun)}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                      <h5 class="fw-semibold m0">Status :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.status_trans}}
                                        </div>
                                    </div>
                                </w-flex>
                            </template>
                            <template v-if="dialogDetail.data.lkp_deposit_trans_id == 2">
                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Jenis Transaksi:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.deposit_trans_keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Tarikh :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{$zutil.dateformat(dialogDetail.data.created_at)}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                      <h5 class="fw-semibold m0">No Rujukan :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.no_rujukan}}
                                        </div>
                                    </div>
                                </w-flex>
                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Penerima Bayaran:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.profill}}
                                        </div>
                                    </div>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">No. Kelulusan:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.no_kelulusan_bayaran}}
                                        </div>
                                    </div>
                                    <div class="xs4">

                                    </div>
                                </w-flex>
                                <template v-if="dialogDetail.data.profil_bayaran == 1">
                                    <w-flex justify-center align-center>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">Akaun:</h5>
                                            <div class="fw-normal my1 fs-1">
                                                {{dialogDetail.data.deposit_trans_keterangan}}
                                            </div>
                                        </div>

                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">Bank :</h5>
                                            <div class="fw-normal my1 fs-1">
                                                {{dialogDetail.data.bank_keterangan}}
                                            </div>
                                        </div>

                                        <div class="xs4">
                                          <h5 class="fw-semibold m0">No Akaun Bank :</h5>
                                            <div class="fw-normal my1 fs-1">
                                                {{dialogDetail.data.no_bank}}
                                            </div>
                                        </div>
                                    </w-flex>
                                </template>
                                <template v-if="dialogDetail.data.profil_bayaran == 2">
                                    <table class="table-dashboard" width="100%">
                                        <thead>
                                            <tr>
                                                <td>Nama Penerima Bayaran </td>
                                                <td>Bank Penerima Bayaran </td>
                                                <td>No. Akaun Penerima Bayaran </td>
                                                <td>Catatan</td>
                                                <td>Amaun Bayaran (RM) </td>
                                            </tr>
                                            </thead><br>

                                        <tbody>
                                            <!-- <tr v-for="(dt, index) in butiran4"> -->
                                            <tr v-for="(dt, index) in dialogDetail.data.deposit_bayaran">
                                                <td >
                                                    {{dt.profil_nama}}
                                                </td>
                                                <td>
                                                    {{dt.bank_keterangan}}
                                                </td>
                                                <td>
                                                   {{dt.no_akaun}}
                                                </td>
                                                <td>
                                                  {{dt.catatan}}
                                                </td>
                                                <td>
                                                    {{ $zutil.currency(dt.amaun)}}
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </template>

                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Keterangan:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Amaun (RM) :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{ $zutil.currency(dialogDetail.data.amaun)}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                      <h5 class="fw-semibold m0">Status :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.status_trans}}
                                        </div>
                                    </div>
                                </w-flex>
                            </template>
                            <template v-if="dialogDetail.data.lkp_deposit_trans_id == 3 || dialogDetail.data.lkp_deposit_trans_id == 4">
                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Jenis Transaksi:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.deposit_trans_keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Tarikh :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{$zutil.dateformat(dialogDetail.data.created_at)}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                      <h5 class="fw-semibold m0">No Rujukan :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.no_rujukan}}
                                        </div>
                                    </div>
                                </w-flex>

                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Keterangan:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">

                                    </div>

                                    <div class="xs4">

                                    </div>
                                </w-flex>

                                <w-flex justify-center align-center>
                                    <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <!-- <td>Bill</td> -->
                                            <td>Kod Akaun</td>
                                            <td>Amaun Debit (RM)</td>
                                            <td>Amaun Kredit (RM)</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(d, ind) in dialogDetail.data.akaund">
                                            <!-- <td>{{ind+1}}</td> -->
                                            <td>{{d.kod}} | {{d.akaun_keterangan}}</td>
                                            <td align="right">{{ $zutil.currency(d.amaun_debit)}}</td>
                                            <td align="right">{{ $zutil.currency(d.amaun_kredit)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                </w-flex>

                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Status :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.status_trans}}
                                        </div>
                                    </div>

                                    <div class="xs4">

                                    </div>

                                    <div class="xs4">

                                    </div>
                                </w-flex>
                            </template>
                            <template v-if="dialogDetail.data.lkp_deposit_trans_id == 5">
                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Jenis Transaksi:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.deposit_trans_keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Tarikh :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{$zutil.dateformat(dialogDetail.data.created_at)}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                      <h5 class="fw-semibold m0">No Rujukan :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.no_rujukan}}
                                        </div>
                                    </div>
                                </w-flex>

                                <w-flex justify-center align-center>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Keterangan:</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.keterangan}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">Amaun (RM) :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{ $zutil.currency(dialogDetail.data.amaun)}}
                                        </div>
                                    </div>

                                    <div class="xs4">
                                      <h5 class="fw-semibold m0">Status :</h5>
                                        <div class="fw-normal my1 fs-1">
                                            {{dialogDetail.data.status_trans}}
                                        </div>
                                    </div>
                                </w-flex>
                            </template>

                            </div>
                          </div>

                            <template #actions>
                            <div class="spacer" />
                            <w-button bg-color="grey-light5--bg" @click="dialogDetail.show = false">Tutup</w-button>
                            </template>
                        </w-dialog>
                        <w-flex class="mt3" wrap align-center justify-end>
                            <w-button
                                class="my1"
                                bg-color="warning"
                                dark
                                @click="back()"
                                >Kembali</w-button
                            >
                        </w-flex>

                </template>

                <template #item-content.3>
                   <z-page title="Paparan Bil">
                        <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode" title="Senarai Bil Deposit">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td>No</td>
                                            <td>Tarikh</td>
                                            <td>No. Bil</td>
                                            <td>NO. RESIT</td>
                                            <td>Keterangan</td>
                                            <td>Amaun (RM)</td>
                                            <td width="1%"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(di, index) in form.indois">
                                            <td>{{ index + 1 }}</td>
                                            <td>
                                                {{
                                                    $zutil.dateformat(
                                                        di.tarikh_inbois
                                                    )
                                                }}
                                            </td>
                                            <td>{{ di.no_inbois }}</td>
                                            <td>{{ di.no_resit }}</td>
                                            <td>{{ di.keterangan }}</td>
                                            <td align="right">
                                                {{ $zutil.currency(di.amaun) }}
                                            </td>
                                            <td>
                                                <w-button
                                                    bg-color="success"
                                                    class="mr3"
                                                    @click="cetak(di.id)"
                                                >
                                                    <w-icon>fal fa-print</w-icon
                                                    >&nbsp;Cetak
                                                </w-button>
                                                <template v-if="di.lkp_inbois_status_id == 2">
                                                <w-button class="my1" bg-color="error-dark1" dark @click="batalInvois(di)">
                                                 <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                                                </w-button>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                    </z-page>

                    <z-page title="Paparan Pelarasan">
                        <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td>No</td>
                                            <td>Tarikh</td>
                                            <td>Jenis Transaksi</td>
                                            <td>Amaun (RM)</td>
                                            <td width="1%"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(dp, index) in form.deposit_trans">
                                           <tr v-if="dp.lkp_deposit_trans_id == 3">
                                                 <td>{{index + 1}}</td>
                                                 <td>{{$zutil.dateformat(dp.created_at)}}</td>
                                                 <td>{{dp.deposit_trans_keterangan}}</td>
                                                 <td>{{$zutil.currency(dp.amaun)}}</td>

                                                 <td><w-button
                                                    bg-color="success"
                                                    class="mr3"
                                                    @click="cetakPel(dp.id)"
                                                ><w-icon>fal fa-print</w-icon
                                                    >&nbsp;Cetak
                                                </w-button></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                    </z-page>

                    <z-page title="Paparan Dokumen">
                        <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td>No</td>
                                            <td>Tarikh</td>
                                            <td>Dokumen</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                       <tr v-for="(d, index) in form.lampiran_deposit">
                                             <td>{{index + 1}}</td>
                                             <td>{{$zutil.dateformat(d.tarikh)}}</td>
                                             <td>
                                                <template v-if="d.nama">
                                                    <a :href="d.nama.replace('http://ihasil-deposit:30006/', 'https://ihasil.kedah.gov.my/api/deposit-service/')" >
                                                        {{ d.nama}}
                                                    </a>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                    </z-page>
                        <w-flex class="mt3" wrap align-center justify-end>
                            <w-button
                                class="my1"
                                bg-color="warning"
                                dark
                                @click="back()"
                                >Kembali</w-button
                            >
                        </w-flex>

                </template>

                <template #item-content.4>
                    <!-- <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="send"> -->
                    <w-form
                        class=""
                        v-model="form.valid"
                        v-model:errors-count="form.errorsCount"
                        @validate="onValidate"
                        @success="send"
                    >
                        <template v-if="form.lkp_deposit_status_id < 13">
                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Jenis Transaksi *
                                </h5>
                            </div>
                            <div class="xs10">
                                <z-lookup
                                    name="Jenis Transaksi"
                                    :url="service_deposit + 'lookup/deposit_trans'"
                                    :sort="false"
                                    :cache="false"
                                    v-model="form.lkp_deposit_trans_id"
                                    :validators="[validators.required]"
                                    placeholder="Jenis Transaksi"
                                >
                                </z-lookup>
                                <!-- <template
                                    v-for="(dt, index) in lkp_deposit_trans"
                                >
                                    <w-radio
                                        v-on:click="jenisTransaksi(form)"
                                        class="mr4"
                                        v-model="form.lkp_deposit_trans_id"
                                        :return-value="dt.value"
                                    >
                                        {{ dt.label }}
                                    </w-radio>
                                </template> -->
                            </div> </w-flex
                        ><br />
                        </template>

                        <template v-if="form.lkp_deposit_trans_id == 2 ">
                             <w-flex >
                                <br><div class="xs2"><br>
                                    <h5 class="fw-semibold m0">No Resit :</h5>
                                </div>
                                <div class="xs10"> <br>
                                    <template v-for="(dt, index) in form.deposit_resit">
                                        {{dt.no_resit}}<br>
                                    </template>
                                </div>
                            </w-flex>
                            <br>
                        </template>

                        <template v-if="form.lkp_deposit_status_id == 13">
                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Jenis Transaksi *
                                </h5>
                            </div>
                            <div class="xs10">
                                <z-lookup
                                    name="Jenis Transaksi"
                                    :url="service_deposit + 'lookup/deposit_trans'"
                                    v-model="form.lkp_deposit_trans_id"
                                    :validators="[validators.required]" disabled
                                >
                                </z-lookup>
                                <!-- <template
                                    v-for="(dt, index) in lkp_deposit_trans"
                                >
                                    <w-radio
                                        v-on:click="jenisTransaksi(form)"
                                        class="mr4"
                                        v-model="form.lkp_deposit_trans_id"
                                        :return-value="dt.value" disabled
                                    >
                                        {{ dt.label }}
                                    </w-radio>
                                </template> -->
                            </div> </w-flex
                        ><br />
                        </template>

                        <w-flex v-if="form.lkp_deposit_trans_id == 3" >
                            <div class="xs2">
                                <h5 class="fw-semibold m0">No. Rujukan *</h5>
                            </div>
                            <div class="xs10">
                                <w-input
                                    class="mb3"
                                    label-position="left"
                                    outline
                                    v-model="form.no_rujukan"
                                    :validators="[validators.required]"
                                >
                                </w-input>
                            </div>
                        </w-flex>
                         <w-flex v-if="form.lkp_deposit_trans_id == 4">
                            <div class="xs2">
                                <h5 class="fw-semibold m0">No. Warta *</h5>
                            </div>
                            <div class="xs10">
                                <w-input
                                    class="mb3"
                                    label-position="left"
                                    outline
                                    v-model="form.no_rujukan"
                                    :validators="[validators.required]"
                                >
                                </w-input>
                            </div>
                        </w-flex>

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Deposit (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.amaun_deposit) }}
                            </div> </w-flex
                        ><br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Deposit Diterima (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.amaun_inbois) }}
                            </div> </w-flex
                        ><br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Baki Deposit Belum Diterima (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.amaun_belum_inbois) }}
                            </div> </w-flex
                        ><br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Bayaran Balik (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.amaun_bayaran) }}
                            </div> </w-flex
                        ><br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Pelarasan (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.amaun_pelarasan) }}
                            </div> </w-flex
                        ><br />

                        <w-flex>
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Pewartaan (RM) :
                                </h5>
                            </div>
                            <div class="xs10">
                                {{ $zutil.currency(form.amaun_pewartaan) }}
                            </div> </w-flex
                        ><br />

                        <w-flex v-if="form.lkp_deposit_trans_id == 1">
                            <div class="xs2">
                                <h5 class="fw-semibold m0">Amaun (RM) *</h5>
                            </div>
                            <div class="xs10">
                                <z-money
                                    v-model:originalValue="form.amaun"
                                    v-on:keyup="baki(form)"
                                    validators="[validators.required]"
                                ></z-money>
                                <div class="w-form-el__error error" v-if="form.amaun > form.amaun_belum_inbois" style="">Amaun Melebihi {{$zutil.currency(form.amaun_belum_inbois)}}</div>

                                <!-- <w-input type="number"
                class="mb3"
                label-position="left"
                outline v-model="form.amaun"
                v-on:keyup="baki(form)"
                :validators="[validators.required]">
              </w-input> -->
                            </div>
                        </w-flex>
                        <w-flex v-if="form.lkp_deposit_trans_id == 2">
                            <div class="xs2">
                                <h5 class="fw-semibold m0">Bayaran Ke :</h5>
                            </div>
                            <div class="xs10">
                                <w-radios v-model="form.profil_bayaran" :items="bayaran" inline></w-radios>
                            </div><br>
                        </w-flex>
                        <w-flex v-if="form.lkp_deposit_trans_id == 2 ">
                            <br><div class="xs2"><br>
                                <h5 class="fw-semibold m0">Nama Pendeposit :</h5>
                            </div>
                            <div class="xs10"> <br>
                                {{form.no_id.toUpperCase()}} | {{form.nama.toUpperCase()}}<br>
                            </div>
                        </w-flex>

                         <w-flex v-if="form.lkp_deposit_trans_id == 2 ">
                            <br><div class="xs2"><br>
                                <h5 class="fw-semibold m0">Resit Asal * :</h5>
                            </div>
                            <div class="xs10"><br>
                                <w-radios v-model="form.is_resit_asal" :items="resitAsal" inline></w-radios>
                            </div>
                        </w-flex>

                         <w-flex v-if="form.lkp_deposit_trans_id == 2 ">
                            <br><div class="xs2"><br>
                                <h5 class="fw-semibold m0">Dokumen Resit :</h5>
                            </div>
                            <div class="xs10">
                                <template v-if="form.is_resit_asal >= 1">
                                    <w-input
                                    class="mt3"
                                    outline
                                    type="file"
                                    v-model="files_resit"
                                    required
                                    >
                                    </w-input>
                                </template>
                                
                            </div>
                        </w-flex>

                         <w-flex v-if="form.lkp_deposit_trans_id == 2 ">
                            <br><div class="xs2"><br>
                                <h5 class="fw-semibold m0">Surat Sumpah * :</h5>
                            </div>
                            <div class="xs10"><br>
                                <w-radios v-model="form.is_surat_sumpah" :items="suratSumpah" inline></w-radios>
                            </div>
                        </w-flex>

                       <!--  <w-flex v-if="form.lkp_deposit_trans_id == 2 ">
                            <br><div class="xs2"><br>
                                <h5 class="fw-semibold m0">Dokumen Surat Sumpah :</h5>
                            </div>
                            <div class="xs10">
                                <template v-if="form.is_surat_sumpah >= 1">
                                    <w-input
                                        class="mt3"
                                        outline
                                        type="file"
                                        v-model="files_sumpah"
                                        required
                                    >
                                    </w-input>
                                </template>
                            </div>
                        </w-flex> -->

                        <w-flex v-if="form.lkp_deposit_trans_id == 5">
                            <div class="xs2"><br>
                                <h5 class="fw-semibold m0">Amaun (RM) *</h5>
                            </div>
                            <div class="xs10"><br>
                                <z-money
                                    v-model:originalValue="form.amaun_tambah_deposit"
                                    validators="[validators.required]"
                                ></z-money>
                            </div>
                        </w-flex>
                        <w-flex v-if="form.lkp_deposit_trans_id == 2">
                            <w-flex v-if="form.profil_bayaran == 1">
                                <div class="xs2"><br>
                                    <h5 class="fw-semibold m0">Amaun (RM)*</h5>
                                </div>
                                <div class="xs10"><br>
                                    <z-money v-model:originalValue="form.amaun" v-on:keyup="baki(form)"
                                        validators="[validators.required]" outline>
                                    </z-money>
                                    <div class="w-form-el__error error"
                                         v-if="form.amaun_baki < 0" style="">Baki Tidak bole kurang
                                    </div>
                                </div><br/>
                            </w-flex>
                        </w-flex>

                        <w-flex v-if="form.lkp_deposit_trans_id == 2"><br>
                            <w-flex v-if="form.profil_bayaran == 1">
                                <div class="xs2"><br>
                                    <h5 class="fw-semibold m0">Bank * :</h5>
                                </div>
                                <div class="xs10"><br>
                                    <z-lookup name="akaun" outline
                                        :url="service_deposit + 'lookup/lkp_bank'"
                                        :sort="false"
                                        :cache="false"
                                        v-model="form.lkp_bank_id"
                                        :validators="[validators.required]" >
                                    </z-lookup>
                                </div><br/>
                            </w-flex>
                        </w-flex>

                        <w-flex v-if="form.lkp_deposit_trans_id == 2">
                            <w-flex v-if="form.profil_bayaran == 1">
                                <div class="xs2"><br>
                                    <h5 class="fw-semibold m0">
                                        No Akaun Bank * :
                                    </h5>
                                </div>
                                <div class="xs10"><br>
                                    <w-input
                                        v-model="form.no_akaun"
                                        required outline
                                        placeholder="Sila Masukan No Akaun Bank"
                                        :validators="[validators.required]">
                                    </w-input>
                                </div>
                            </w-flex>
                        </w-flex>
                        <w-flex v-if="form.lkp_deposit_trans_id == 2">

                            <w-flex v-if="form.profil_bayaran == 2"><br>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td>Nama Penerima Bayaran *</td>
                                            <td>Bank Penerima Bayaran *</td>
                                            <td>No. Akaun Penerima Bayaran *</td>
                                            <td>Catatan</td>
                                            <td>Amaun Bayaran (RM) *</td>
                                            <td> <w-icon class="mr1" @click="addBayaran">fal fa-plus</w-icon></td>
                                        </tr>
                                    </thead><br>
                                    <tbody>
                                        <tr v-for="(val, index) in deposit_bayaran">
                                            <td>
                                                <z-input
                                                    v-model="val.bayaran_profil_keterangan"
                                                    name="profil_id" readonly
                                                    @click="profil(index)"
                                                    :validators="[validators.required]"/>
                                            </td>
                                            <td>
                                                <z-lookup name="akaun"
                                                    :url='service_utiliti+"lookup/bank"'
                                                    :sort="false" :cache="false"
                                                    v-model="val.bayaran_lkp_bank_id"
                                                    :validators="[validators.required]"/>
                                            </td>
                                            <td>
                                                <w-input v-model="val.bayaran_no_akaun" required
                                                    :validators="[validators.required]"/>
                                            </td>
                                            <td>
                                                <w-input v-model="val.bayaran_catatan"/>
                                            </td>
                                            <td>
                                                <z-money v-model:originalValue="val.amaun"
                                                    v-on:keyup="totalBayaran()"
                                                    :validators="[validators.required]"/>
                                                <div class="w-form-el__error error"
                                                    v-if="form.amaun_baki < 0" style="">
                                                    Baki Tidak bole kurang
                                                </div>
                                            </td>
                                            <td>
                                                <w-icon class="mr1" @click="removeBayaran(index)">fal fa-trash</w-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                    </w-flex>
                    <w-dialog
                          v-model="dialogProfil.show"
                          :fullscreen="dialogProfil.fullscreen"
                          :width="dialogProfil.width"
                          :persistent="dialogProfil.persistent"
                          :persistent-no-animation="dialogProfil.persistentNoAnimation"
                          title-class="primary-light1--bg white">
                        <template #title>
                            <w-icon class="mr2">fal fa-user</w-icon>
                            Carian Profil
                        </template>
                            <div class="page-wrapper-portal">
                                <w-flex justify-center align-center>
                                    <div class="xs8">
                                        <w-input label="No KP | Nama (Carian minimun 2 aksara)"
                                            v-model="carian_profil.q" >
                                        </w-input>
                                    </div>
                                    <div class="xs4">
                                        <w-button class="ml1" @click="cariProfil">Cari</w-button>
                                    </div>
                                </w-flex>
                                <div class="table-profil-scrol">
                                <table class="w-table ">
                                    <thead>
                                        <tr>
                                            <th class="w-table__header w-table__header--sortable text-left">No</th>
                                            <th class="w-table__header w-table__header--sortable text-left">No KP | Nama</th>
                                            <th class="w-table__header w-table__header--sortable text-left">Pilih</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="dt, index in profils">
                                            <td class="w-table__cell text-left">{{(index+1)}}</td>
                                            <td class="w-table__cell ">{{dt.label}}</td>
                                            <td class="w-table__cell text-right">
                                                <w-radio class="mr2"
                                                    v-model="deposit_bayaran[i_ind].bayaran_profil_id"
                                                    :return-value="dt.value" @click="pilihProfil(dt.label)">
                                                </w-radio>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        <template #actions>
                            <div class="spacer"/>
                                <w-button bg-color="grey-light5--bg" @click="dialogProfil.show = false">    Tutup
                                </w-button>
                        </template>
                    </w-dialog>
            <!-- </div> -->

                        <!-- </div> -->

                        <!-- <w-flex> -->
                        <w-flex v-if="form.lkp_deposit_trans_id == 3">
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Pelarasan (RM) * :
                                </h5>
                            </div>
                            <div class="xs10">
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td>Akaun</td>
                                            <td>Debit(RM)</td>
                                            <td>
                                                <w-icon @click="addItem"
                                                    >fal fa-plus</w-icon
                                                >
                                            </td>
                                        </tr>
                                    </thead>
                                    <br />
                                    <tr v-for="(dt, index) in butiran">
                                        <td>
                                            <z-lookup
                                                class="mb4"
                                                :url="
                                                    service_deposit +
                                                    'lookup/akaun_akhir'
                                                "
                                                :sort="false"
                                                :cache="false"
                                                v-model="dt.akaun_id"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                            >
                                            </z-lookup>
                                        </td>
                                        <td>
                                           <!--  <z-money
                                                class="mb4"
                                                v-model:originalValue="
                                                    dt.amaun_debit
                                                "
                                                v-on:keyup="totalAmaun()"
                                                validators="[validators.required]"
                                            ></z-money> -->

                                           <!--  <z-money v-model:originalValue="dt.amaun_debit" v-on:keyup="totalAmaun()"  :validators="[validators.required]"/>

                                                <div class="w-form-el__error error" v-if="form.amaun_baki < 0" style="">
                                                    Baki Tidak bole kurang
                                                </div> -->

                                                <z-money
                                                    v-model:originalValue="dt.amaun_debit"
                                                    @keyup="totalAmaun"
                                                    :validators="[validators.required]"
                                                    />
                                                <div class="w-form-el__error error" v-if="Number(dt.amaun_debit) <= 0">
                                                    Amaun debit mesti lebih daripada 0
                                                </div>
                                                <div class="w-form-el__error error" v-if="form.amaun_baki < 0" >
                                                    Baki tidak boleh kurang
                                                </div>

                                            <!--  <w-input
                                                class="mb4"
                                                v-model="dt.amaun_debit" v-on:keyup="totalAmaun()"
                                                :validators="[validators.required]">
                                            </w-input> -->
                                        </td>
                                        <w-icon
                                            class="mr1"
                                            @click="removeItem(index)"
                                            >fal fa-trash</w-icon
                                        >
                                    </tr>
                                </table>
                            </div>
                        </w-flex>

                        <w-flex v-if="form.lkp_deposit_trans_id == 4">
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Amaun Pelarasan (RM) * :
                                </h5>
                            </div>
                            <div class="xs10">
                                <table width="100%">
                                    <thead>
                                    <tr>
                                        <td>Akaun</td>
                                        <td>Debit(RM)</td>
                                        <!-- <td>
                        <w-icon class="mr1" @click="addItem4">fal fa-plus</w-icon>
                      </td> -->
                                    </tr>
                                    </thead><br>
                                    <tr v-for="(dt, index) in butiran4">
                                        <td>
                                            <z-lookup
                                                class="mb4"
                                                :url="
                                                    service_deposit +
                                                    'lookup/akaun_akhir'
                                                "
                                                :sort="false"
                                                :cache="false"
                                                v-model="dt.akaun_id"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                            >
                                            </z-lookup>
                                        </td>
                                        <td>
                                            <z-money
                                                class="mb4"
                                                v-model:originalValue="
                                                    dt.amaun_debit
                                                "
                                                v-on:keyup="totalAmaunPewartaan()"
                                                validators="[validators.required]"
                                            ></z-money>
                                            <!-- <w-input
                        class="mb4"
                        label="Debit(RM)"
                        v-model="dt.amaun_debit"
                        v-on:keyup="totalAmaun()" :validators="[validators.required]">
                      </w-input> -->
                                        </td>
                                        <!-- <td>
                      <w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon>
                    </td> -->
                                    </tr>
                                </table>
                            </div>
                        </w-flex>

                       <!--  <br
                            v-if="
                                form.lkp_deposit_trans_id == 4 ||
                                form.lkp_deposit_trans_id == 3
                            "
                        /> -->
                        <w-flex
                            v-if="
                                form.lkp_deposit_trans_id == 4 ||
                                form.lkp_deposit_trans_id == 3
                            "
                        ><br>
                            <div class="xs2"><br>
                                <h5 class="fw-semibold m0">Amaun (RM) :</h5>
                            </div>
                            <div class="xs10"><br>
                                {{ $zutil.currency(form.amaun) }}
                            </div><br>
                        </w-flex>

                        <!-- <br
                            v-if="
                                form.lkp_deposit_trans_id == 4 ||
                                form.lkp_deposit_trans_id == 3
                            "
                        /> -->
                        <!-- <br v-if="form.lkp_deposit_trans_id" /> -->
                        <w-flex v-if="
                                form.lkp_deposit_trans_id == 2 ||form.lkp_deposit_trans_id == 4 ||
                                form.lkp_deposit_trans_id == 3
                            ">
                            <div class="xs2"><br>
                                <h5 class="fw-semibold m0">
                                    Baki Akhir (RM) :
                                </h5>
                            </div>
                            <div class="xs10"><br>
                                {{ $zutil.currency(form.amaun_baki) }}
                            </div>
                        </w-flex
                        >

                        <w-flex v-if="form.lkp_deposit_trans_id == 2 ">
                            <br><div class="xs2"><br>
                                <h5 class="fw-semibold m0">No. Kelulusan * :</h5>
                            </div>
                            <div class="xs10"><br>
                                <w-input
                                    class="mb3"
                                    label-position="left"
                                    outline
                                    v-model="form.no_kelulusan_bayaran"
                                    :validators="[validators.required]"
                                >
                                </w-input>
                            </div>
                        </w-flex>
                        <w-flex v-if="form.lkp_deposit_trans_id == 1"><br>
                            <div class="xs2"><br>
                                <h5 class="fw-semibold m0">
                                    Baki Belum Bil (RM) :
                                </h5>
                            </div>
                            <div class="xs10"><br>
                                {{ $zutil.currency(form.amaun_baki) }}
                            </div> </w-flex
                        >

                        <w-flex><br>
                            <div class="xs2"><br>
                                <h5 class="fw-semibold m0">Keterangan *</h5>
                            </div>
                            <div class="xs10"><br>
                                <w-textarea
                                    class="mb3"
                                    label-position="left"
                                    outline
                                    v-model="form.keterangan_trans"
                                    :validators="[validators.required]"
                                >
                                </w-textarea>
                            </div>
                        </w-flex>

                        <w-flex v-if="form.lkp_deposit_trans_id">
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                    Dokumen sokongan
                                </h5>
                            </div>
                            <div class="xs10">
                                <w-input
                                    class="mt3"
                                    outline
                                    type="file"
                                    v-model="files"
                                    required
                                >
                                </w-input>
                            </div> </w-flex
                        >

                        <w-flex class="mt3" wrap align-center justify-end>
                            <w-button class="my1"
                                bg-color="warning" dark
                                @click="back()" >Kembali</w-button>
                            &nbsp;&nbsp;
                            <w-button class="mr2"
                                bg-color="warning"
                                type="reset" @click="clear()">Reset
                            </w-button>
                            <template v-if="!isHidden && form.lkp_deposit_status_id < 13">
                                <!-- <w-button class="my1"
                                    :loading="form.submitted && !form.sent" disabled>
                                    <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon>
                                    Hantar
                                </w-button> -->
                            </template>
                            <template v-if="form.amaun <= form.amaun_belum_inbois  && form.lkp_deposit_trans_id == 1" >
                                <template v-if="form.lkp_deposit_trans_id == 1 && $zutil.can('Deposit Penyediaan')">
                                  <template v-if="form.lkp_deposit_trans_id == 1 ||form.amaun_baki < 0">
                                    <w-button
                                        class="my1" type="submit"
                                        :disabled="form.valid === false"
                                        :loading="form.submitted && !form.sent">
                                        <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon>
                                        Hantar
                                    </w-button>
                                  </template>
                                </template>
                            </template>

                        <template v-else-if="form.amaun_baki >= 0 && form.lkp_deposit_trans_id != 1">
                            <template v-if="form.lkp_deposit_trans_id == 2 && $zutil.can('Deposit Penyediaan')">
                            <template v-if="form.lkp_deposit_trans_id == 2 || form.amaun_baki < 0 ">
                                <w-button
                                    type="submit" class="my1"
                                    :disabled="form.valid === false"
                                    :loading="form.submitted && !form.sent">
                                    <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                                    Hantar
                                </w-button>
                            </template>
                            </template>
                            <template v-if="form.lkp_deposit_trans_id == 3 && $zutil.can('Deposit Penyediaan')">
                            <template v-if=" form.lkp_deposit_trans_id == 3 || form.amaun_baki < 0">
                                <!-- <w-button
                                    type="submit" class="my1"
                                    :disabled="form.valid === false"
                                    :loading="form.loading && !form.sent">
                                    <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                                    Hantar
                                </w-button> -->
                                <w-button
                                 type="submit"
                                 class="my1"
                                 :disabled="!isAmaunValid || form.valid === false"
                                 :loading="form.loading && !form.sent">
                                 <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                                 Hantar
                                </w-button>
                            </template>
                            </template>
                            <template v-if="form.lkp_deposit_trans_id == 4 && $zutil.can('Deposit Penyediaan')">
                            <template v-if="form.lkp_deposit_trans_id == 4 || form.amaun_baki < 0 ">
                                <w-button
                                    type="submit" class="my1"
                                    :disabled="form.valid === false"
                                    :loading="form.submitted && !form.sent">
                                    <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                                    Hantar
                                </w-button>
                            </template>
                            </template>
                            <template v-if="form.lkp_deposit_trans_id == 5 && $zutil.can('Deposit Penyediaan')">
                            <template v-if="form.lkp_deposit_trans_id == 5">
                                <w-button
                                    type="submit" class="my1"
                                    :disabled="form.valid === false"
                                    :loading="form.submitted && !form.sent">
                                    <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
                                    Hantar
                                </w-button>
                            </template>
                            </template>
                        </template>
                        <template v-else>
                            <w-button
                                class="my1" :disabled="true">
                                <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon>
                                    Hantar
                                </w-button>
                        </template>
                        </w-flex>
                    </w-form>
                </template>

                <template #item-content.5>

                        <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td width="2%">No</td>
                                            <td width="15%">Tarikh</td>
                                            <td>Pengguna</td>
                                            <td>Status</td>
                                            <td>Catatan</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                dt, index
                                            ) in form.jejak_audit"
                                        >
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ dt.tarikh }}</td>
                                            <td>{{ dt.user_nama }}</td>
                                            <td>
                                                {{ dt.tindakan_keterangan }}
                                            </td>
                                            <td>{{ dt.catatan }}</td>
                                        </tr>
                                        <tr v-if="form.jejak_audit.length == 0">
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                        <w-flex class="mt3" wrap align-center justify-end>
                            <w-button
                                class="my1"
                                bg-color="warning"
                                dark
                                @click="back()"
                                >Kembali</w-button
                            >
                        </w-flex>

                </template>
            </w-tabs>
        </z-page>
        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Batal Deposit
            </template>
            <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">
               <w-flex justify-space-between class="mb4">
                   <z-input
                        label="Catatan Batal *"
                        name="catatan_batal"
                        v-model="form.catatan_batal"
                        :validators="[validators.required]"/>
              </w-flex>
            </w-form>


            <template #actions>
                <div class="spacer" />
                  <w-button class="my1" bg-color="primary"  dark :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="sendBatal(13)" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Hantar
                  </w-button>
                    &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            isHidden: false,
            resourceurl: this.service_deposit + "deposit",
            reload: true,
            lkp_deposit_trans: [],
            deposit_trans: [],
            deposit: [],
            butiran: [{ akaun_id: null, amaun_debit: 0 }],
            butiran4: [{ akaun_id: 470, amaun_debit: 0.0 }],
            deposit_bayaran: [{bayaran_profil_id : null, bayaran_profil_keterangan : null, bayaran_lkp_bank_id : null, bayaran_no_akaun : null, bayaran_catatan : null, amaun : null}],
            files: [],
            files_resit: [],
            files_sumpah: [],
            dialogDetail: {
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                data : {}
            },
            dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },
            form : {
              loading: false,
            },
            selection: true,
            bayaran: [
                {
                    value: 1,
                    label: "Pendeposit",
                },
                {
                    value: 2,
                    label: "Lain - lain",
                },
            ],
            resitAsal: [
                {
                    value: 1,
                    label: "Ya",
                },
                {
                    value: 0,
                    label: "Tidak",
                },
            ],
            suratSumpah: [
                {
                    value: 1,
                    label: "Ya",
                },
                {
                    value: 0,
                    label: "Tidak",
                },
            ],
            i_ind : null,
            id : null,
            carian_profil : {q: ''},
            profils : [],
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: {nama: '', email: ''}
            },
            tabs: [
                { title: "Profil", content: "" },
                { title: "Transaksi", content: "" },
                { title: "Lain-Lain", content: "" },
                { title: "Tindakan", content: "" },
                { title: "Jejak Audit", content: "" },
            ],
            activeTab : 0,
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Deposit", route: "/deposit" },
                { label: "Papar", route: "/deposit/" + this.id },
            ],
            validators: {
                required: (value) => !!value || "Medan ini wajib diisi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        };
    },
    methods: {
        clear () {
        this.getData()
          this.files = false
          this.files_resit = false
          this.files_sumpah = false
          this.$nextTick(() => {
            this.files = true
            this.files_resit = true
            this.files_sumpah = true
          })
        },
        batalInvois(form){
          form.lkp_inbois_status_id = 4
          this.$zcomm.update(this.service_bil_pelbagai+'inbois' + '/'+form.id, form.id, form)
                      .then(res => {


                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit()
                          }
                          this.$inertia.visit(this.$route('deposit.index'))
                      })
                      .catch(err => {

                      })
                      .finally(() => {


                      });

        },
        change() {
          console.log('filechange');
        },
        back() {
            window.history.back();
        },

        BatalDeposit() {
            this.dialog.show = 1;
        },

        depostTrans() {
            this.$zcomm
                .get(this.service_deposit + "lookup/deposit_trans")
                .then((res) => {
                    this.lkp_deposit_trans = res;
                })
                .catch((err) => {})
                .finally(() => {
                    this.totalAmaun()
                });
        },
        jenisTransaksi(form){
          this.isHidden = true
          if(form.lkp_deposit_trans_id == 4){

            this.butiran4[0].amaun_debit = form.amaun_baki
          }
          this.totalAmaunPewartaan();
        },

        baki(form) {
            if(form.lkp_deposit_trans_id != 1){
                const inbois_amaun = this.form.amaun_inbois ? this.form.amaun_inbois : 0;
                const bayaran_amaun = this.form.amaun_bayaran ? this.form.amaun_bayaran : 0;
                const pelarasan_amaun = this.form.amaun_pelarasan ? this.form.amaun_pelarasan : 0;
                const pewartaan_amaun = this.form.amaun_pewartaan ? this.form.amaun_pewartaan : 0;
                // var baki = form.amaun_deposit -
                //     (form.amaun_inbois +
                //     form.amaun_bayaran +
                //     form.amaun_pelarasan +
                //     form.amaun_pewartaan);
                // var baki =
                // form.amaun_inbois -
                //     ( form.amaun_bayaran +
                //     form.amaun_pelarasan +
                //     form.amaun_pewartaan);

                    var baki = Number(inbois_amaun) - ( Number(bayaran_amaun) + Number(pelarasan_amaun) + Number(pewartaan_amaun));


            }else if(form.lkp_deposit_trans_id == 1){
            var baki =
                form.amaun_belum_inbois;
                    // form.amaun_deposit -
                    // (form.amaun_inbois +
                    // form.amaun_bayaran +
                    // form.amaun_pelarasan +
                    // form.amaun_pewartaan);

              }

                form.amaun_baki = baki - (form.amaun);
        },

        totalAmaun() {
            this.form.amaun = 0;
            for (var i in this.butiran) {
                this.butiran[i].amaun_debit;
                this.form.amaun =
                    this.form.amaun + parseFloat(this.butiran[i].amaun_debit);
            }
            this.baki(this.form);
        },
        totalAmaunPewartaan() {
            this.form.amaun = 0;
            for (var i in this.butiran) {
                this.butiran4[i].amaun_debit;
                this.form.amaun =
                    this.form.amaun + parseFloat(this.butiran4[i].amaun_debit);
            }
            this.baki(this.form);
        },
        totalBayaran() {
            this.form.amaun = 0;
            for (var i in this.deposit_bayaran) {
                this.deposit_bayaran[i].amaun;
                this.form.amaun =
                    this.form.amaun + parseFloat(this.deposit_bayaran[i].amaun);
            }
            this.baki(this.form);
        },

        send() {
            if(this.form.lkp_deposit_trans_id == 3){
                const invalidAmaun = this.butiran.some(
                    dt => Number(dt.amaun_debit) <= 0
                    );
                if (invalidAmaun) {
                    this.$toast?.error?.('Amaun debit mesti lebih daripada 0');
                    return;
                }

                // tukar ke NUMBER sebelum hantar
                this.form.butiran = this.butiran.map(dt => ({
                    ...dt,
                    amaun_debit: Number(dt.amaun_debit)
                }));
            }


        // this.upload();
          if(this.form.valid == true){
            this.form.butiran = this.butiran;
            this.form.butiran4 = this.butiran4;
            this.form.deposit_bayaran = this.deposit_bayaran;
            this.form.loading = true
            this.$zcomm
                .update(
                    this.resourceurl + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit();
                    }

                    this.getData();
                    this.activeTab=1;
                    this.submitLoading=true;
                    // this.$inertia.visit(this.$route("deposit.index"));

                    this.upload(res.id);
                    this.uploadResit(res.id);
                    this.uploadSumpah(res.id);
                   


                })
                .catch((err) => {})
                .finally(() => {
                        // this.form.loading = false; 
                });
              }
        },
        sendBatal(status) {
            // alert (status);
          this.form.lkp_deposit_status_id = status
              if(this.form.valid == true){
                this.$zcomm
                    .update(
                        this.resourceurl + "/"+this.form.id,
                        this.form.id,
                        this.form
                    )
                    .then((res) => {
                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit();
                        }

                        this.$inertia.visit(this.$route("deposit.index"));

                        // this.upload(res.id);
                    })
                    .catch((err) => {})
                    .finally(() => {
                        // this.upload(res.id);
                    });
                  }
            },


        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\DepositTrans");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    this.getData();
                    this.activeTab=1;
                    this.submitLoading=true;
                    // this.$inertia.visit(this.$route("deposit.index"));
                })
                .catch((err) => {})
                .finally(() => {});
        },

        uploadResit(id) {
            let formData = new FormData();
            formData.append('file', this.files_resit[0].file);
            formData.append("model", "App\\Models\\DepositTrans");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    this.getData();
                    this.activeTab=1;
                    this.submitLoading=true;
                    // this.$inertia.visit(this.$route("deposit.index"));
                })
                .catch((err) => {})
                .finally(() => {});
        },
        uploadSumpah(id) {
            let formData = new FormData();
            formData.append('file', this.files_sumpah[0].file);
            formData.append("model", "App\\Models\\DepositTrans");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    this.getData();
                    this.activeTab=1;
                    this.submitLoading=true;
                    // this.$inertia.visit(this.$route("deposit.index"));
                })
                .catch((err) => {})
                .finally(() => {});
        },

        addItem() {
            this.butiran.push({ akaun_id: null, amaun_debit: 0 });
        },
        removeItem(index) {
            this.butiran.splice(index, 1);
        },

        addItem4() {
            this.butiran4.push({ akaun_id: 470, amaun_debit: 0.0 });
        },
        removeItem4(index) {
            this.butiran.splice(index, 1);
        },

        cetak(id) {
            // window.location.href = this.service_bil_pelbagai+'inbois/cetak'+id;
            window.location.href = this.service_deposit + "deposit/cetak/" + id;
        },
        cetakPel(id) {
            // window.location.href = this.service_bil_pelbagai+'inbois/cetak'+id;
            window.location.href = this.service_deposit + "deposit/cetak_pel/" + id;
        },
        addBayaran() {
            this.deposit_bayaran.push({ bayaran_profil_id : null, bayaran_profil_keterangan : null, bayaran_lkp_bank_id : null, bayaran_no_akaun : null, bayaran_catatan : null, amaun : null });
        },
        removeBayaran(index) {
            this.deposit_bayaran.splice(index, 1);
        },
        cekAmaun(){
          this.form.amaun = 0;
          for (var i in this.form.deposit_bayaran) {
            this.form.amaun = this.form.amaun + parseFloat(this.form.deposit_bayaran[i].amaun);
          }
        },
        profil(i_ind){
          this.i_ind = i_ind
          this.dialogProfil.show = 1
        },

        showInfo(dt){
          this.dialogDetail.show = 1
          this.dialogDetail.data = dt
        },

        cariProfil(){
          if(this.carian_profil.q.length > 1){
            this.$zcomm.post(this.service_utiliti+"lookup/profil", this.carian_profil, {})
            .then(res => {
              console.log(res)
                this.profils = res
              })
          }
        },

        pilihProfil(bayaran_profil_keterangan){
          this.deposit_bayaran[this.i_ind].bayaran_profil_keterangan = bayaran_profil_keterangan
        },
    },
    computed: {
        isAmaunValid() {
            return this.butiran.every(dt =>
                dt.amaun_debit !== null &&
                dt.amaun_debit !== '' &&
                dt.amaun_debit !== null &&
                dt.amaun_debit !== 0 &&
                dt.amaun_debit !== undefined
                );
        }
    },

    watch: {},
    mounted() {
        this.depostTrans();
        this.butiran4 = [{akaun_id : 470, amaun_debit : 0.00} ]
        if(this.id == 0){
            this.form = {
            show: true,
            deposit_bayaran : [{ bayaran_profil_id : null, bayaran_profil_keterangan : null, bayaran_lkp_bank_id : null, bayaran_no_akaun : null, bayaran_catatan : null, amaun : null } ]}
        }
    },

};
</script>
